import React, { useState, useEffect } from "react";
import { Button, Avatar } from "@mui/material";
import { FaList } from "react-icons/fa";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import EditableTextField2 from "../../EditableTextField2";
import CommentsPadrao from "../CommentsPadrao";
import { Span, Div, Flex } from "../../../style";
import getCookie from "../../../hooks/getCookie";
import { getAvatarUrl } from "../../../utils/getAvatarUrl";

export default function SideMenuPadrao({}) {
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const storedUserId = getCookie("userId");
  const sessionId = getCookie("session_id");

  const [newComment, setNewComment] = useState("");
  const [isLogsVisible, setIsLogsVisible] = useState(false);

  return (
    <div style={{ display: "flex" }} className="atividades-logs">
      <div>
        <Flex
          style={{
            marginBottom: "20px",
            marginLeft: "5px",
            display: "flex",
            justifyContent: "space-between",
            height: "0px",
            paddingBottom: "15px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaList style={{ fontSize: "20px", marginRight: "15px" }} />
            <Span style={{}}>Atividade</Span>
          </div>
          <Flex style={{ alignItems: "center", justifyContent: "center" }}>
            <Button
              style={{ textTransform: "none" }}
              className="button-show-details"
            >
              {isLogsVisible ? "Ocultar Detalhes" : "Mostrar Detalhes"}
            </Button>
            <KeyboardDoubleArrowDownIcon
              id="scrollToBottomIcon"
              style={{ cursor: "pointer" }}
            />
          </Flex>
        </Flex>
        <Flex  className="button-actions" style={{ marginBottom: "20px", width: "260px", padding: "10px" }}>
          <Div>Adicione um novo comentário...</Div>
        </Flex>
        <div className="container-comments">
          <div>
            <CommentsPadrao comments1={["activity.data"]} />

            <Div className="comment log-item">
              <Flex>
                <div>
                  <Flex>
                    <Avatar
                      className="comment-avatar"
                      src={getAvatarUrl("lesteboard")}
                      sx={{ width: 24, height: 24, ml: -1 }}
                      title="Lesteboard"
                    />
                    <Flex
                      style={{
                        flexDirection: "column",
                        maxWidth: "25vw",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Span className="comment-timestamp">
                        {"Eu sou um log de alteração do card"}
                      </Span>
                      <Span className="user-comments" style={{ color: "#666" }}>
                        {"aqui aparece o dia e hora da alteração"}
                      </Span>
                    </Flex>
                  </Flex>
                </div>
              </Flex>
            </Div>
          </div>
        </div>
      </div>
    </div>
  );
}
